<template>
  <div class="bjt">
    <div class="xhx"></div>
    <div style="width:80%;margin:0 auto">

      <div class="bottfour">

        <!-- <div>
          <div class="gyzh">关于展会</div>
          <div class="gyzhnr">
            <span @click="zgpmt('2','7','展会历程')">·&nbsp;展会历程</span>
            <span @click="zgpmt('2','2','组织机构')">·&nbsp;组织机构</span>
          </div>
          <div class="gyzhnr">
            <span @click="zgpmt('2','5','展馆导览')">·&nbsp;展馆导览</span>
            <span @click="zgpmt('2','3','主办单位')">·&nbsp;主办单位</span>
          </div>
          <div class="gyzhnr">
            <a style="font-size:16px" href="https://mp.weixin.qq.com/s/PdYC7U867_xi2gpJC4hJKQ"><span>·&nbsp;展后报告</span></a>

            <span @click="zgpmt('2','6','展会声明')">·&nbsp;展会声明</span>
          </div>
          <div class="gyzhnr">
            <span @click="zgpmt('2','1','展会总览')">·&nbsp;展会总览</span>
            <span @click="zgpmt('8','1','8')">·&nbsp;往届回顾</span>
          </div>
          <div class="gyzhnr">
            <span @click="zgpmt('2','4','展会光荣榜')">·&nbsp;展会光荣榜</span>

          </div>
        </div> -->
        <div>
          <div class="lxwm">
          Contact us
          </div>
          <div class="lxwmnr">
            <div>
              <img src="../assets/home/dianhua.png" alt="">&nbsp;&nbsp;&nbsp;
              010-52806519
            </div>
            <div>
              <img src="../assets/home/xinxi.png" alt="">&nbsp;&nbsp;&nbsp;
              intl@caepi.org.cn
            </div>
            <div>
              <img src="../assets/home/dizhi.png" alt="">&nbsp;&nbsp;&nbsp;
                No. 6, Erqi Theater Road, Xicheng District, Beijing
            </div>
          </div>
        </div>
        <div>
          <img src="../assets/home/20220906105253.png" alt="">
          <div class="tptext">
           China Association of Environmental Protection Industry
          </div>
        </div>
        <div>
          <img src="../assets/home/20190911065538.png" alt="">
          <div class="tptext">
            China International Environmental Protection Exhibition and Conference
          </div>
        </div>
      </div>
      <div class="bqsy">
        版权所有：中国环境保护产业协会京ICP备11046034号-4
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Bottom',
  data () {
    return {
      tableData: [{ name: '生态环境部', url: 'https://www.mee.gov.cn/' },
        { name: '生态环境部固体废物与化学品管理技术中心', url: 'https://www.meescc.cn/' },
        { name: '北京市人民政府', url: 'https://www.beijing.gov.cn/' },
        { name: '中国国际商会', url: 'http://www.ccoic.cn/' },
        { name: '中国环境保护产业协会', url: 'http://www.caepi.org.cn/' },
        { name: '商务部外贸发展事务局', url: 'http://www.tdbmofcom.org.cn/' },
        { name: '中国环境科学研究院', url: 'https://www.craes.cn/' },
        { name: '中国环境监测总站', url: 'https://www.cnemc.cn/' },
        { name: '生态环境部环境规划院', url: 'http://www.caep.org.cn/' },
        { name: '生态环境部土壤与农业农村生态环境监管技术中心', url: 'http://www.tcare-mee.cn/' },
        { name: '中国环境报社', url: 'https://www.cenews.com.cn/' },
        { name: '生态环境部对外合作与交流中心', url: 'http://www.fecomee.org.cn/' },
        { name: '生态环境部南京环境科学研究所', url: 'https://www.nies.org/' },
        { name: '生态环境部华南环境科学研究所', url: 'http://www.scies.org/' },
        { name: '生态环境部环境工程评估中心', url: 'https://www.china-eia.com/' }
      ],

      translateNum: 0,
      timer: null,
      value1: '',
      value2: '',
      exhibitorsSwiper: []
    }
  },
  mounted () {
    // this.search()
    this.getExhibitorsData()
  },
  beforeDestroy () {
    // 销毁定时器，否则可能导致重载此组件时会有多个定时器同时执行，使得滚动变快
    window.clearTimeout(this.timer)
  },
  methods: {
    getExhibitorsData () {
      let dataList = this.tableData // 获取到数据
      for (let i = 0; i < dataList.length; i += 5) {
        this.exhibitorsSwiper.push(dataList.slice(i, i + 5))
      }
    },
    zgpmt (index1, index2, index3) {
      this.value1 = index1
      this.value2 = index2
      this.$emit('childFn', this.value1, this.value2, index3)
    }
    // search () {
    //   // 循环给tableData数组每一个对象添加translateNum属性为0，这也是为了方便记录每一个对象滚动的宽度
    //   for (var i = 0; i < this.tableData.length; i++) {
    //     this.$set(this.tableData[i], 'translateNum', 0)
    //   }

    //   // 在元素完全渲染后再循环给每一个对象添加indexLeft属性，记录此对象初始位置，方便滚动超出父元素边界后，重新设置元素位置
    //   this.$nextTick(() => {
    //     for (var j = 0; j < this.tableData.length; j++) {
    //       this.$set(this.tableData[j], 'indexLeft', this.$refs.demoItem[j].offsetLeft)
    //     }

    //     // 调用滚动定时器
    //     this.roll()
    //   })
    // },

    // roll () {
    //   this.timer = setInterval(() => {
    //     // 循环给每一个对象修改translateNum属性值，从而动态修改页面元素的transform样式，达到滚动的效果
    //     for (var i = 0; i < this.tableData.length; i++) {
    //       /**
    //        * 判断此元素是否即将超出父级元素carousel-item的显示区域
    //        * 1400 = 父级元素carousel的宽度 + 一个子元素carousel-item的宽度（如果元素有间距也需要带上）即 1200 + 180 + 20(间距)
    //        * 修改父级元素与子元素样式时需要留意此处也应当一起修改
    //        */
    //       if (1600 - this.tableData[i].translateNum - this.tableData[i].indexLeft < 0) {
    //         /**
    //          * 如果超出，则将元素移动至父级元素显示区域的左方
    //          * 此处的200 对应着子元素carousel-item的样式宽度
    //          */
    //         this.$set(this.tableData[i], 'translateNum', this.$refs.all.offsetLeft - this.tableData[i].indexLeft)
    //       }

    //       // 设置每个元素每次滚动的像素大小，像素越小越平滑,这里每次只移动一个像素
    //       this.$set(this.tableData[i], 'translateNum', this.tableData[i].translateNum + 1)
    //     }
    //   }, 10) // 30毫秒滚动一次，时间间隔越短滚动越平滑
    // },

    /**
     * 鼠标悬停销毁定时器
     */
    // mouseOver () {
    //   window.clearTimeout(this.timer)
    // },

    /**
     * 鼠标离开再次执行定时器
     */
    // mouseLeave () {
    //   this.roll()
    // }

  }
}
</script>

<style  scoped>
.exhibitors {
  flex: 1;
  height: 85px !important;
}
.flex-center-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.exhibitors-cont {
  /* width: 80%; */
  height: 200px;
  margin: 0 auto;
}

/deep/ .el-carousel__container {
  height: 85px !important;
}

::v-deep .el-carousel__arrow {
  background-color: rgba(255, 255, 255, 1);
  color: rgba(46, 53, 143, 1);
}
.exhibitors-item-section {
  color: #fff;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 85px;
}
.exhibitors-item-section:nth-child(2n) {
  margin: 0 15px;
}
.exhibitors-item-img {
  width: 100%;
  height: 150px;
}
a {
  text-decoration: none;
  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 500;
}
.bjt {
  background-image: url('../assets/home/footbg.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-size: cover; /* 设置背景图片宽度100%，高度自动 */
  background-position: center; /* 背景图片居中 */
  height: 550px; /* 元素高度 */
}
.xhx {
  width: 99.8%;
  position: relative;
  top: 85px;
  border: 1px solid rgba(47, 47, 47, 0.21);
  box-shadow: 0px 1px 1px 0px rgba(196, 196, 196, 0.5);
}
.yqlj {
  height: 85px; /* 元素高度 */
  display: flex;
}
.leftlj {
  background-image: url('../assets/home/lianjie.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  display: flex;
  height: 85px;
  align-items: center;
  justify-content: center;
  width: 226px;
}
.rightlj {
  flex: 1;
  display: flex;
  align-items: center;
  margin-left: 20px;
  justify-content: space-between;
}

.bottfour {
  display: flex;
  justify-content: space-between;
  margin-top: 105px;
}
.ksdh {
  font-size: 22px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 500;
  margin-bottom: 15px;
}
.ksdhnr {
  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 48px;
  font-weight: 400;
}
.gyzh {
  font-size: 22px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 500;
  margin-bottom: 15px;
}
.gyzhnr {
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 48px;
  font-weight: 400;
  cursor: pointer;
}
.lxwm {
  font-size: 22px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 500;
  margin-bottom: 15px;
}
.lxwmnr {
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 42px;
  font-weight: 400;
}
.tptext {
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 400;
  text-align: center;
  margin-top: 15px;
}
.bqsy {
  font-size: 16px;
  color: #fff;
  letter-spacing: 0;
  line-height: 25.2px;
  font-weight: 400;
  text-align: center;
  margin-top: 70px;
}

.carousel-item {
  width: 320px !important;
  height: 85px;

  white-space: nowrap;

  text-align: center;
  margin: 10px 20px;
}
</style>>



// WEBPACK FOOTER //
// src/components/bottomeng.vue